"use client";

import { FetchButton } from "@/fetch-ui/FetchButton";
import { Plus } from "lucide-react";
import { POST_NIGHT_LABEL, PRE_NIGHT_LABEL } from "@/lib/utils/accommodations";
import type { ShoulderSegment } from "../../../_types/wizard-types";

interface AddShoulderNightRowProps {
  /** Which side of the program the button adds a night to. */
  segment: ShoulderSegment;
  /** Number of table columns the row spans. */
  colSpan: number;
  /** Called with `segment` when clicked. */
  onAdd: (segment: ShoulderSegment) => void;
}

/**
 * Full-width table row with an "Add pre-night" / "Add post-night" button, rendered above the first
 * row or below the last one. Adding a night here extends the room block, never the program dates.
 *
 * @param props - The side to add to, the row's column span, and the add handler.
 * @returns The table row.
 */
export function AddShoulderNightRow({ segment, colSpan, onAdd }: AddShoulderNightRowProps) {
  // Derived values
  const label = `Add ${(segment === "pre" ? PRE_NIGHT_LABEL : POST_NIGHT_LABEL).toLowerCase()}`;

  // Render
  return (
    <tr>
      <td colSpan={colSpan} className="px-5 py-1.5">
        <FetchButton
          variant="ghost"
          color="neutral"
          size="xs"
          leftIcon={<Plus className="size-3.5" aria-hidden />}
          onClick={() => onAdd(segment)}
        >
          {label}
        </FetchButton>
      </td>
    </tr>
  );
}
